import axios from "axios";
import MockAdapter from "axios-mock-adapter";
import { getFirestore, doc, getDoc } from "firebase/firestore"; // Import Firestore functions
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth,onAuthStateChanged } from "firebase/auth"
import { app } from "./firebaseInitial";
import config from "../config";
import toast from "react-hot-toast";


const analytics = getAnalytics(app);
const db = getFirestore(app); // Initialize Firestore
const auth = getAuth(app);

axios.defaults.baseURL = config.API_URL;


axios.interceptors.response.use(
  response => response, // Just pass through if successful
  error => {
    if (error.response && error.response.status === 401) {
      // Token expired or unauthorized
      console.log("Token expired or unauthorized, logging out...");

      // Clear any auth data
      localStorage.removeItem("authUser");

      // Optional: redirect to login
      window.location.href = "/logout"; // adjust to your route

      // Optionally reject to halt further execution
      return Promise.reject(error);
    }

    return Promise.reject(error); // For all other errors
  }
);


  // const fetchUserDetails = async (userId) => {
  //   try{
  //   const userDoc = doc(db, "users", userId); // Assuming user data is stored in 'users' collection
  //   const userSnapshot = await getDoc(userDoc);
  //   if (userSnapshot.exists()) {
  //     console.log("User data:-->", userSnapshot.data());
  //      // Return user data
  //   } else {
  //     console.log("No such user!");
  //     return null;
  //   }
  //   }
  //   catch(error)
  //   {
  //         if (error.code === "unavailable" || error.message.includes("offline")) {
  //         toast.error("You are offline",position="bottom-left")
  //   } else {
  //     console.error("Firestore error:", error);
  //   }
  //   }
  // };
  
  // fetchUserDetails('11190')



// let users = [
//   {
//     id: 1,
//     name: "WMConnect",
//     username: "themesbrand",
//     password: "123456",
//     email: "ramveer.webmobril@gmail.com",
//     role: "role",
//     token: token,
//   },
// ];
let users = [];

// const fetchUsersFromApi = async () => {
//   try {
//     const response = await axios.post("/product/login/"); // Replace with your API endpoint
//     users = response.data; // Assuming the API returns an array of users
//   } catch (error) {
//     console.error("Error fetching users:", error);
//   }
// };


// fetchUsersFromApi();

const fakeBackend = () => {
  // This sets the mock adapter on the default instance
  // const mock = new MockAdapter(axios);

  // mock.onPost("/register").reply(function (config) {
  //   const user = JSON.parse(config["data"]);
  //   user.id = users.length + 1;
  //   users.push(user);

  //   return new Promise(function (resolve, reject) {
  //     setTimeout(function () {
  //       resolve([200, user]);
  //     });
  //   });
  // });

  // mock.onPost("/login").reply(function (config) {
  //   const user = JSON.parse(config["data"]);
  //   const validUser = users.filter(
  //     (usr) => usr.email === user.username && usr.password === user.password
  //   );
  //   {console.log("user checked-->",users)}
  //   return new Promise(function (resolve, reject) {
  //     setTimeout(function () {
  //       if (validUser["length"] === 1) {
  //         resolve([200, validUser[0]]);
  //       } else {
  //         reject({
  //           message:
  //             "Username and password are invalid. Please enter correct username and password",
  //         });
  //       }
  //     });
  //   });
  // });

  // mock.onPost("/forget-pwd").reply(function (config) {
  //   // User needs to check that user is eXist or not and send mail for Reset New password

  //   return new Promise(function (resolve, reject) {
  //     setTimeout(function () {
  //       resolve([200, "Check your mail and reset your password."]);
  //     });
  //   });
  // });
};

export default fakeBackend;
